import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function TermsOfUse() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
      {/* Hero Section */}
      <div className="hero-banner">
        <div className="hero-content">
          <h1>{t('terms_of_use')}</h1>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_section1')}</p>
        </div>
      </div>

      {/* Content Section */}
      <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par1')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par1')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par2')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par2')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par3')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par3')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par4')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par4')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par5')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par5')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par6')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par6')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par7')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par7')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par8')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par8')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par9')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par9')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('terms_of_use_title_par10')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('terms_of_use_par10')}</p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
